



































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { formRules } from '@/common/util/validator';
import { LoginApi, UserApi } from '@/http';
var md5 = require('js-md5');
import { MessageBox, Message } from 'element-ui';
import { default as JSEncrypt } from 'jsencrypt';
@Component({})
export default class Login extends Vue {
    pwdForm = {
        id:'',
        oldPassword:'',
        password:'',
        repeatPassword:'',
    }
    public canLogin: boolean = true;
    public disYzm: boolean = false;
    public toastText: string = '';
    public onLine = navigator.onLine;
    public bgClass = 'sj';
    // public activeName: string = 'first';
    public checked: boolean = true;
    public loading: boolean = false;
    public checkMobile(phoneNumber?) {
        var regu = /^1[123456789]\d{9}$/;
        var re = new RegExp(regu);
        if (!!phoneNumber) {
            if (re.test(phoneNumber)) {
                return true;
            } else {
                return false;
            }
        } else {
            if (re.test(this.loginForm.userName)) {
                return true;
            } else {
                return false;
            }
        }
    }
    public checkCode(code?) {
        var regu = /^\d{4}$/;
        var re = new RegExp(regu);
        if (!!code) {
            if (re.test(code)) {
                return true;
            } else {
                return false;
            }
        }
    }
    // public handleClick(tab, event) {
    //     this.canShow = false;
    //     if (this.activeName == 'second') {
    //         this.loginForm.userName = '';
    //         this.loginForm.password = '';
    //     } else {
    //         this.loginForm1.phoneNumber = '';
    //         this.loginForm1.password = '';
    //         this.loginForm1.code = '';
    //     }
    // }

    public transitionName: string = '';
    public yzmLogin: boolean = true;
    public userLogin: boolean = true;
    public canShow: boolean = false;
    industryList = [];
    public $refs: {
        loginForm: HTMLFormElement;
        loginForm1: HTMLFormElement;
        registerForm: HTMLFormElement;
        selTouch: HTMLFormElement;
        ruleForm: HTMLFormElement;
    };

    public loginForm = {
        userName: '',
        password: '',
        code: '',
    };
    public loginForm1 = {
        phoneNumber: '',
        password: '',
        code: '',
    };
    public btnMessage: string = '获取验证码';
    public countDowning: boolean = false;
    @Watch('loginForm', { deep: true })
    public loginFormPwdChange(loginForm) {
        if (loginForm.userName && loginForm.password) {
            this.userLogin = false;
        } else if (!loginForm.userName || !loginForm.password) {
            this.userLogin = true;
        }
    }

    @Watch('loginForm1', { deep: true })
    public loginForm1PwdChange(loginForm1) {
        if (loginForm1.phoneNumber.length == 11 && loginForm1.code.length == 4) {
            this.canLogin = false;
        } else {
            this.canLogin = true;
        }
        if (loginForm1.phoneNumber.length == 11 && !this.isSend) {
            this.disYzm = false;
        } else {
            this.disYzm = true;
        }
    }
    /**
     * 倒计时
     */
    interval: any;
    public formRules = formRules;
    public openId: string = '';
    public year: number = new Date().getFullYear();
    created() {
        this.canShow = false;
        this.detectZoom();
        this.$nextTick(() => {
            window.addEventListener('resize', () => {
                // 监听浏览器窗口大小改变
                this.detectZoom();
                // 浏览器变化执行动作
            });
        });
        window.addEventListener('online',this.updateOnlineStatus);
        window.addEventListener('offline',this.updateOfflineStatus);
    }
    mounted() {
        let urlPath = window.location.href;
        let mlssloginAd = localStorage.getItem('mlssloginAd') ? JSON.parse(localStorage.getItem('mlssloginAd')).jwtToken : '';
        let res  = localStorage.getItem('mlssloginAd') ? JSON.parse(localStorage.getItem('mlssloginAd')) : '';
        if (mlssloginAd && urlPath.includes('/login')) {
            // this.$router.push('/addOrder');
             if (res.webMenus.includes('fbfhjh2')) {
                    this.$router.push({
                        path: '/addOrder',
                    });
            } 
            else {
                //过滤出二级权限
                let level2 = res.webMenus.split(',').filter((item) => {
                        return item.indexOf('2') > 0;
                });                 
                this.correspond.forEach((i) => {                      
                    level2.forEach((e) => {
                    if (e == i.menus) {
                        this.routAddress.push(i.path);
                    }
                });
            });
            this.$router.push(this.routAddress[0]);
            }        
        }
        var that = this;
        document.onkeydown = () => {
            var key = (window as any).event.keyCode;
            if (key === 13) {
                that.handleLogin();
            }
        };
        if (!this.loginForm1.phoneNumber) {
            this.disYzm = true;
        }
        this.bodyScale();
        window.onresize = () => {
            this.bodyScale();
        };
    }
    public isScale: boolean = false;
    bodyScale() {
        var devicewidth = document.documentElement.clientWidth;
        if (devicewidth <= 1400) {
            this.isScale = true;
        } else {
            this.isScale = false;
        }
    }
    updateOnlineStatus(e) {
        this.onLine = true;
        // const { type } = e;
        // this.onLine = type === 'online';
    }
    updateOfflineStatus(e) {
        this.onLine = false;
        // const { type } = e;
        // this.onLine = type === 'online';
    }
    beforeDestroy() {
        window.removeEventListener('online', this.updateOnlineStatus);
        window.removeEventListener('offline', this.updateOfflineStatus);
    }
    resetForm(formName) {
        if (this.$refs[formName] !== undefined) {
            this.$refs[formName].resetFields();
        }
        switch (formName) {
            case 'loginForm':
                break;
            case 'loginForm1':
                break;
            case 'registerForm':
                break;
            default:
                break;
        }
    }
    public isSend: boolean = false;
    getCode() {
        if (this.checkMobile(this.loginForm1.phoneNumber)) {
            this.canShow = false;
            if (!this.disYzm) {
                LoginApi.GetCode({
                    phoneNumber: this.loginForm1.phoneNumber,
                }).then(() => {
                    this.$message.success('验证码已发送');
                    this.isSend = true;
                    this.countCode();
                });
            }
        } else {
            this.toastText = '手机号输入错误';
            this.canShow = true;
        }
    }
    /**
     * 倒计时
     */
    countCode() {
        this.disYzm = true;
        this.countDowning = true;
        let i = 60;
        this.interval = setInterval(() => {
            this.btnMessage = `${--i}秒后重试`;
            if (i === 0) {
                clearInterval(this.interval);
                this.btnMessage = '获取验证码';
                this.disYzm = false;
                this.isSend = false;
                this.countDowning = false;
            }
        }, 1000);
    }
    /**
     * 登录
     */
    public routAddress: any = [];
    //权限对应路由
    public correspond = [
        // {
        //     menus: 'xmgl2', //项目管理
        //     path: './projectManager',
        // },
        // {
        //     menus: 'xjfd2', //单笔询价发布
        //     path: './AddInquiry',
        // },
        // {
        //     menus: 'xjd2', //单笔询价
        //     path: './SingleInquiry',
        // },
        // {
        //     auth: 'fbgc2', //发布工程询价
        //     path: './AddInquiryEng',
        // },
        // {
        //     auth: 'xjg2', //工程询价
        //     path: './SingleInquiryEng',
        // },
        // {
        //     auth: 'htg2', //合同
        //     path: './contractManage',
        // },
        // {
        //     auth: 'fhfd2', //发货-发布订单
        //     path: './addOrder',
        // },
        // {
        //     auth: 'fhd2', //发货-订单管理
        //     path: './ordermanager',
        // },
        // {
        //     auth: 'fhy2', //发货-运单管理
        //     path: './WayBillManage',
        // },
        {
            menus: 'fbfhjh2', //发货-发布发货计划
            path: './addOrder',
        },
        {
            menus: 'fhjh2', //发货-发货计划管理
            path: './orderManager',
        },
        {
            menus: 'whyjsh2', //发货-网货运价审核
            path: './orderAcceptManager',
        },
        {
            menus: 'cdyjtb2', //发货-车队运价填报
            path: './orderPayManager',
        },
         {
            menus: 'ydgl2', //发货-运单管理
            path: './WayBillManage',
        },
        // {
        //     menus: 'yykb2', //预约排队看板
        //     path: './callBorad',
        // },
        // {
        //     menus: 'yykb2', //叫号
        //     path: './callManage',
        // },
        // {
        //     menus: 'yypd2', //预约排队
        //     path: './queueManage',
        // },
        {
            menus: 'ycgl2', //异常管理
            path: './errorManager',
        },
        {
            menus: 'hdgl2', //回单管理
            path: './receiptManager',
        },
        // {
        //     auth: 'jcf2', //费用类型维护
        //     path: './expenseType',
        // },
        {
            menus: 'yffy2', //应付费用
            path: './payManagement',
        },
        {
            menus: 'yfdzd2', //应付对账单
            path: './payStatement',
        },
        {
            menus: 'ysfy2', //应收费用
            path: './receivableManagement',
        },
        {
            menus: 'ysdzd2', //应收对账单
            path: './receivableStatement',
        },
        {
            menus: 'fwfzd2', //服务费账单
            path: './serviceStatement',
        },
         {
            menus: 'sjfx2', //数据分析
            path: './dataAnalysis',
        },
        {
            menus: 'cdgl2', //车队管理
            path: './carrierManager',
        },
        // {
        //     auth: 'jcck2', //仓库管理
        //     path: './storeManagement',
        // },
        // {
        //     auth: 'jcyt2', //月台管理
        //     path: './platformManagement',
        // },
        // {
        //     auth: 'jcsjck2', //时间窗口设置
        //     path: './timeWindow',
        // },
        // {
        //     auth: 'cwfsh2', //费用审核
        //     path: './costAudit',
        // },
        // {
        //     auth: 'cwf2', //费用明细
        //     path: './costDetail',
        // },
        // {
        //     auth: 'cwd2', //费用对账单
        //     path: './costStatement',
        // },
        // {
        //     auth: 'cy2', //承运商管理
        //     path: './carrierManager',
        // },
        // {
        //     menus: 'jcf2', //费用类型维护
        //     path: './expenseType',
        // },
        // {
        //     menus: 'cy2', //承运商管理
        //     path: './carrierManager',
        // },

        // {
        //     menus: 'cyhx2', //承运商画像
        //     path: './carrierPortrait',
        // },
        // {
        //     menus: 'cyk2', //KPI考核
        //     path: './carrierKPI',
        // },
        // {
        //     menus: 'yls2', //司机管理
        //     path: './capacity',
        // },
        // {
        //     menus: 'ylc2', //车辆管理
        //     path: './carManager',
        // },
         {
            menus: 'sjgl2', //司机管理
            path: './dirverManager',
        },
        {
            menus: 'clgl2', //车辆管理
            path: './carManager',
        },
        {
            menus: 'sjzd2', //数据字典
            path: './dictionary',
        },
        {
            menus: 'jzjpz2', //基准价配置
            path: './basePriceConfig',
        },
         {
            menus: 'fhfhtj2', //发货方合同价
            path: './shipperContractPriceConfig',
        },
        {
            menus: 'cdhtj2', //车队合同价
            path: './fleetContractPriceConfig',
        },
        {
            menus: 'fylxwh2', //费用类型维护
            path: './expenseType',
        },
        {
            menus: 'fhfgl2', //客户/基地管理
            path: './shipManagement',
        },
         {
            menus: 'dzb2', //地址簿
            path: './addressBook',
        },
        // {
        //     menus: 'pzy2', //运价表配置
        //     path: './freightConfig',
        // },
        // {
        //     menus: 'pztzgg2', //通知公告
        //     path: './notifications',
        // },
        {
            menus: 'qxgl2', //权限管理
            path: './permissonSetting',
        },
        {
            menus: 'bmgl2', //部门管理
            path: './departManagement',
        },
        {
            menus: 'jsgl2', //角色管理
            path: './roleManagement',
        },
        {
            menus: 'yhgl2', //用户管理
            path: './userMangement',
        },
        {
            menus: 'grzx2', //个人中心
            path: './personal',
        },
        {
            menus: 'jkrz2', //接口日志
            path: './crudManage',
        },
    ];
    public isShowAd: any; //该字段传值给用户管理页面，判断是否管理员且无权限
    handleLogin() {
         this.loading = true;
        if (!this.onLine) {
            this.canShow = true;
            this.toastText = '网络连接失败，请稍后再试！';
            this.loading = false;
            return;
        }
            const jsencrypt = new JSEncrypt({});
            jsencrypt.setPublicKey(
            'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCBgNziL0nb/pCXvg+NlNhwyAB8zmzN3T2W0EDy35W3XH0rgsE7Tn9XNzVZmnxkrdumTgc/EhMStNvuD8tAG+yxktIhoWM56FvE8T5/OlBtXzU6GxX3WBWNOmz/e0ktYEzTeiD2eI2KQpLekZXPpZ+sZmDIBCdDUJQVpTYGx1KtoQIDAQAB'
            );
            let password = jsencrypt.encrypt(this.loginForm.password);
            // let password = md5(this.loginForm.password)
            let obj: any = {
                password: password,
                userName: this.loginForm.userName,
            };
            
            this.$refs.loginForm.validate((valid) => {
                if (valid) {
                    LoginApi.Login(obj)
                        .then((res) => {
                            this.pwdForm.id = res.id
                            localStorage.setItem('mlssloginAd', JSON.stringify(res));
                            const regex4 = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+{};:,<.>|\[\]\\\/?]).{6,30}$/;
                            if (regex4.test(this.loginForm.password)){
                                this.doLogin(res)
                            }else{
                                this.userLogin = false
                                this.loading = false
                                this.showChangePwd = true
                            }  
                        })
                        .catch((e) => {
                            this.toastText = e;
                            this.canShow = true;
                            this.loading = false;
                        });
                } else {
                    this.canShow = true;
                    this.toastText = '请先输入用户名和密码';
                    this.loading = false;
                }
            });
         
    }
    public showChangePwd:boolean = false;
    doUpdatePwd(){
       this.$refs.ruleForm.validate(async (valid)=>{
        if(valid){
             if (this.pwdForm.password == this.pwdForm.oldPassword) {
                MessageBox.alert('新密码不能与旧密码一致，请核实', '提示', {
                    confirmButtonText: '确定',
                    type: 'warning',
                }).then(() => {});
                return
            }
            if (this.pwdForm.password != this.pwdForm.repeatPassword) {
                MessageBox.alert('确认密码与新密码不一致，请核实', '提示', {
                    confirmButtonText: '确定',
                    type: 'warning',
                }).then(() => {});
                return
            }
           await UserApi.UpdatePW({
                ...this.pwdForm,
            })
            this.$message.success('修改密码成功,请重新登录!')
            this.showChangePwd = false
            this.userLogin = false
            this.loading = false
            this.loginForm.password = ''
         }
       })
    }
    handleClose(){
       this.pwdForm = {
            id:'',
            oldPassword:'',
            password:'',
            repeatPassword:'',
        }
        this.$refs.ruleForm.resetFields();
        this.showChangePwd = false
    }
    doLogin(res){
        if (res.isAdmin == true && !res.webMenus) {
            this.isShowAd = 'true';
            localStorage.setItem('isShowAd', JSON.stringify(this.isShowAd));
            res.webMenus = 'fh1,fbfhjh2,fbfhjh3,fhjh2,fhjhzk3,fhjhxz3,fhjhsdxf3,fhjhqh3,fhjhbbdc3,dyzyd3,bjfhjh3,zjfhjh3,scfhjh3,wcfhjh3,wlhyyffyzk3,cdyffyzk3,whyjsh2,whyjsh3,cdyjtb2,cdyjtbzk3,cdyjtb3,ydgl2,ydzk3,yddw3,yffydj3,ysfydj3,ydbbdc3,yffyzk3,yffybjsc3,ysfyzk3,ysfybjsc3,ycdj3,szglyd3,ycgl1,ycgl2,ycglzk3,ycbbdc3,hd1,hdgl2,hdzk3,hdbbdc3,cw1,yffy2,yffyzk3,yffybj3,yfbbdc3,yfdzd2,yfdzdzk3,xzzd3,yfzdbbdc3,ysfy2,ysfyzk3,ysfybj3,ysbbdc3,ysdzd2,ysdzdzk3,xzzd3,yszdbbdc3,fwfzd2,sjtj1,sjfx2,cd1,cdgl2,ylc1,sjgl2,sjzk3,sjjyqy3,sjtb3,clgl2,clzk3,cljyqy3,cltb3,pzgl1,sjzd2,jzj2,xzjzj3,bjjzj3,ljsx3,ljshix3,fhfhtj2,xzfhfhtj3,bjfhfhtj3,ljsx3,ljshix3,cdhtj2,xzcdhtj3,bjcdhtj3,ljsx3,ljshix3,jzzl1,fhfgl2,fylxwh2,dzb2,xtsz1,qxgl2,bmgl2,jsgl2,yhgl2,grzx2,jkrz2,ycglsh3,ycglsc3'
        }

        if (!res.webMenus) {
            res.webMenus = '';
            this.$message.error('该账号未开通登录权限，请联系管理员处理！');
            this.loading = false;
            return;
        }
        localStorage.setItem('mlssloginAd', JSON.stringify(res));
        if (res.webMenus.includes('fbfhjh2')) {
            this.$router.push({
                path: '/addOrder',
            });
        } else {
            //过滤出二级权限
            let level2 = res.webMenus.split(',').filter((item) => {
                return item.indexOf('2') > 0;
            });                 
            this.correspond.forEach((i) => {                      
                level2.forEach((e) => {
                    if (e == i.menus) {
                        this.routAddress.push(i.path);
                    }
                });
            });
            this.$router.push(this.routAddress[0]);
        }
        this.loading = false;
    }
    public jobClick() {
        this.canShow = false;
    }

    public inpitfocus(id) {
        $(`#${id}`).parent().parent().css('border', '1px solid #327DFE');
    }

    public inputblur(id) {
        $(`#${id}`).parent().parent().css('border', '1px solid #DCDFE6');
    }
    // 监听
    public loginbottom = '';
    public loginboxHeight = '';
    public infotitle2 = '';
    public infotitle = '';
    public ratio = 0;
     detectZoom() {
        this.ratio = 0;
        const screen: any = window.screen;
        const ua = navigator.userAgent.toLowerCase();
        if (window.devicePixelRatio !== undefined) {
            this.ratio = window.devicePixelRatio;
        } else if (~ua.indexOf('msie')) {
            if (screen.deviceXDPI && screen.logicalXDPI) {
                this.ratio = screen.deviceXDPI / screen.logicalXDPI;
            }
        } else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
            this.ratio = window.outerWidth / window.innerWidth;
        }
        if (this.ratio) {
            this.ratio = Math.round(this.ratio * 100);
        }
        if (this.ratio <= 100) {
           this.infotitle = 'info100';
           this.infotitle2 = 'info2100';
           this.loginboxHeight  ='loginboxHeight100'
           this.loginbottom = 'loginbottom100'
        } else if (this.ratio == 110) {
          this.infotitle = 'info110';
          this.infotitle2 = 'info2110';
          this.loginboxHeight = 'loginboxHeight110'
          this.loginbottom = 'loginbottom110'
        } else if (this.ratio == 125) {
             this.infotitle = 'info125';
             this.infotitle2 = 'info2125';
             this.loginboxHeight = 'loginboxHeight125'
            this.loginbottom = 'loginbottom125'
        } else if (this.ratio >= 150) {
            this.infotitle = 'info150';
            this.infotitle2 = 'info2150';
            this.loginboxHeight = 'loginboxHeight150'
            this.loginbottom = 'loginbottom150'
        }
    }
}
